import { OsappError } from "apps/idl/src/model/errors/OsappError";
import { ObjectHelper } from "apps/idl/src/helpers/objectHelper";

export class ForwardActionError extends OsappError {
	constructor(psMessage: string) {
		super(`Erreur d'action d'avancement d'une facture: ${psMessage}`);
		// Nécessaire pour que le 'instanceof ForwardActionError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, ForwardActionError);
	}
}